import * as React from 'react';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { IBreadcrumb } from '../../types/newbuilding/breadcrumb';

import * as style from './BreadCrumbs.css';

export interface IBreadCrumbsProps {
  breadCrumbs: IBreadcrumb[];
}

export const BreadCrumbs = ({ breadCrumbs }: IBreadCrumbsProps): React.JSX.Element => {
  return (
    <div className={style['container']} aria-label="Ссылки на поиск по квартирам">
      {breadCrumbs.map((crumb, index) => {
        const fullUrl = crumb.fullUrl || '/';
        const title = crumb.title || 'Ссылка';

        return (
          <React.Fragment key={`${title}${index}`}>
            {index === 0 ? null : (
              <span className={style['arrow']}>
                <IconActionChevronRightSmall16 color={'icon-secondary-default'} />
              </span>
            )}
            <a className={style['crumb']} href={fullUrl} title={title}>
              {title}
            </a>
          </React.Fragment>
        );
      })}
    </div>
  );
};
